import React from 'react'

import { useRemoteStrings } from '@acorns/web-utils'

import { APP_STORE_URL, GOOGLE_PLAY_URL } from 'app-constants'
import { isAndroid, isMobile } from 'components/Trackers/platform'
import {
  AppStoreButtonTappedEvent,
  ButtonTappedEvent,
  GooglePlayButtonTappedEvent,
} from 'pages/MOC/Success/events'
import { TestIDs } from 'test/utils/testIds'
import trackEvent from 'utils/analytics/trackEvent'
import { EnvironmentProps, withEnv } from 'utils/environment'
import { getFlow } from 'utils/FlowProvider/utils'

import AppStore from './AppStore.svg'
import GooglePlay from './GooglePlay.svg'
import { MOCButton } from './styled-components'

type Props = EnvironmentProps

export const Button = withEnv(({ env }: Props) => {
  const { getRemoteString } = useRemoteStrings()
  const desktopCtaText = getRemoteString({ key: 'registration.success.cta' })

  const handleCtaPress = () => {
    if (isMobile()) {
      trackEvent('Button Tapped', {
        eventData: isAndroid() ? GooglePlayButtonTappedEvent : AppStoreButtonTappedEvent,
        flow: getFlow(),
      })
      window.location.replace(isAndroid() ? GOOGLE_PLAY_URL : APP_STORE_URL)
    } else {
      trackEvent('Button Tapped', {
        eventData: ButtonTappedEvent(desktopCtaText),
        flow: getFlow(),
      })
      window.location.replace(env.get('webAppUrl'))
    }
  }

  return (
    <MOCButton onPress={handleCtaPress} data-testid={TestIDs.SUCCESS.OPEN_ACORNS_CTA}>
      {isMobile() ? (
        <img src={isAndroid() ? GooglePlay : AppStore} alt={'Mobile application download button'} />
      ) : (
        desktopCtaText
      )}
    </MOCButton>
  )
})
